import packageJson from "../../package.json";

export const config = {
  commitHash: import.meta.env.VITE_COMMIT_HASH || "???????",
  version: packageJson.version,
  nodeEnvironment: import.meta.env.VITE_NODE_ENV,
  appEnvironment: import.meta.env.VITE_APP_ENV,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT,
  v1ApiBaseUrl: import.meta.env.VITE_V1_API_BASE_URL,
  postHogKey: import.meta.env.VITE_POSTHOG_KEY,
  postHogHost: import.meta.env.VITE_POSTHOG_HOST,
  url: import.meta.env.VITE_URL,
  configcatKey: import.meta.env.VITE_CONFIGCAT_API_KEY,
  azureClientId: import.meta.env.VITE_AZURE_CLIENT_ID,
  azureTenantId: import.meta.env.VITE_AZURE_TENANT_ID,
  azureAudience: import.meta.env.VITE_AZURE_AUDIENCE,
  carCutterCustomerToken:
    import.meta.env.VITE_CARCUTTER_CUSTOMER_TOKEN || "1a7136e1b91c8898b5ceff1d7dcb85e41f77a17fa64f7267d60b0fd5e99005d2",
};

export const isDev = config.nodeEnvironment === "development";
export const isDevStage = config.appEnvironment === "dev";
